import { useEffect, useState } from "react";
import { ChallengeContext } from "../../types/Challenge";
import { useParams } from "react-router-dom";
import { getChallengeContext } from "../../api";

const useChallengeContext = () => {
  const { catalog = "all", challengeId } = useParams<{
    challengeId: string;
    catalog: string;
  }>();
  const [context, setContext] = useState<ChallengeContext>({
    pre_id: null,
    nxt_id: null,
    rnd_id: null,
  });

  useEffect(() => {
    if (!challengeId) return;
    getChallengeContext(catalog, Number(challengeId)).then(setContext);
  }, [catalog, challengeId])

  return {
    context,
    challengeId,
    catalog
  };
}

export default useChallengeContext;
